import './ui/settings.css';

import { useEffect, useRef, useState } from 'react';
import { Button, IconBut } from '../ui/buttons';
import { Profilepic } from './MainApp';


export default function Settings() {
    const viewRef = useRef();

    return (
        <div className="settings view" ref={viewRef}>
            <div className='content max'>
                <Upgrade />
                <div className="pp">
                    <Profilepic />
                    <div className='abs' style={{ bottom: "0", right: "10px" }}>
                        <IconBut className="fa-solid fa-camera" />
                    </div>
                </div>
                <Personal />
                <Apperance />
                <Preferences />
                <Offline />
                <HelpNFeedback />
            </div>
        </div>
    )
}


function Upgrade() {
    return (
        <div className="up">
            <Button> Upgrade </Button>
        </div>
    )
}

function Personal() {
    return (
        <label>
            <small>Name</small>
        </label>
    )
}

function Apperance() {
    return (
        <div></div>
    )
}

function Preferences() {
    return (
        <div></div>
    )

}

function Offline() {
    return (
        <div></div>
    )


}

function HelpNFeedback() {
    return (
        <div></div>
    )

}